export default "__VITE_ASSET__2a2ade35__"